import { Table, TableBody, TableRow, TableCell } from "@mui/material";
import { ProductDetail } from "../types";
import { useMarketplaceStore } from "../../../../store/useMarketplaceStore";
import { useTranslation } from "../../../../hooks/useTranslation";
import { Cancel, CheckCircle, Close, Done } from "@mui/icons-material";
import { PriceDisplayBox } from "../../../inventory/components/PriceDisplayBox";
import { Section } from "./Section";

type OtherSellersProps = {
  productDetail?: ProductDetail;
};

export const OtherSellers = ({ productDetail }: OtherSellersProps) => {
  const selectedCountry = useMarketplaceStore((state) => state.selectedCountry);
  const { translate, translateWithoutPrefix } = useTranslation("pages.product");

  return (
    <Section title={translate("otherSeller")}>
      <Table size="small">
        <TableBody>
          <TableRow>
            <TableCell>{translate("buyBoxPrice")}</TableCell>
            <TableCell>
              <PriceDisplayBox
                price={productDetail?.marketplaceProduct?.buyBoxPriceAmount}
                color={productDetail?.buyBoxWinner ? "green" : "gray"}
                StartIcon={productDetail?.buyBoxWinner ? Done : Close}
                percentage={productDetail?.competitiveBuyBoxMarginPercentage}
              />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>{translate("lowestPrice")}</TableCell>
            <TableCell>
              <PriceDisplayBox
                price={productDetail?.marketplaceProduct?.lowestPriceAmount}
                color={productDetail?.lowestPrice ? "green" : "gray"}
                StartIcon={productDetail?.lowestPrice ? Done : Close}
                percentage={productDetail?.competitiveMinMarginPercentage}
              />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              {translate("localOfferCount", {
                localStore: selectedCountry?.countryName,
              })}
            </TableCell>
            <TableCell>
              {productDetail?.marketplaceProduct?.totalOfferCount ?? "Unknown"}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>{translate("buyBoxEligibleOfferCount")}</TableCell>
            <TableCell>
              {productDetail?.marketplaceProduct?.buyBoxEligibleOfferCount ??
                translateWithoutPrefix("common.unknown")}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>{translate("hasFBASeller")}</TableCell>
            <TableCell>
              {productDetail?.marketplaceProduct?.hasFBASeller ? (
                <CheckCircle fontSize="small" sx={{ color: "green" }} />
              ) : (
                <Cancel fontSize="small" sx={{ color: "red" }} />
              )}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>{translate("hasSBASeller")}</TableCell>
            <TableCell>
              {productDetail?.marketplaceProduct?.hasSBASeller ? (
                <CheckCircle fontSize="small" sx={{ color: "green" }} />
              ) : (
                <Cancel fontSize="small" sx={{ color: "red" }} />
              )}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>{translate("hasShipFromChina")}</TableCell>
            <TableCell>
              {productDetail?.marketplaceProduct?.hasShipFromChina ? (
                <CheckCircle fontSize="small" sx={{ color: "green" }} />
              ) : (
                <Cancel fontSize="small" sx={{ color: "red" }} />
              )}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Section>
  );
};
